export default __webpack_public_path__ + "static/media/cotizador.774c2cfa.jpg";